import { render, staticRenderFns } from "./awards-read-only.vue?vue&type=template&id=793048b6&lang=pug&"
import script from "./awards-read-only.vue?vue&type=script&lang=js&"
export * from "./awards-read-only.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports